import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PlaylistStatus } from "@src/types/playlist";

export type IPlaylistFilter = {
  searchText?: string;
  showTitle?: string;
  showId?: string;
  playlistName?: string;
  durationInMinutes?: number;
  guestCuratorId?: string;
  playlistStatus?: PlaylistStatus;
  subcuratorsIds?: string[];
  id?: string;
  lastModified?: {
    startDate?: Date;
    endDate?: Date;
  };
  dateAired?: {
    startDate?: Date;
    endDate?: Date;
  };
  description?: string;
  // not client side
  curatorId?: string;
  role?: string;
  isSubcurator?: boolean;
  playlistProcessedAudioNotNull?: boolean;
  playlistProcessedAudioDurationGte?: number;

  isForMood?: boolean;
};
export type PlaylistSort = {
  field: string;
  direction: "asc" | "desc";
};

export const ADMIN_DEFAULT_PLAYLIST_SORT: PlaylistSort = {
  field: "id",
  direction: "desc",
};

export const CURATOR_DEFAULT_PLAYLIST_SORT: PlaylistSort = {
  field: "id",
  direction: "desc",
};

export function getDefaultPlaylistSort(role?: string): PlaylistSort {
  if (role === "admin" || role === "manager") {
    return ADMIN_DEFAULT_PLAYLIST_SORT;
  }
  return CURATOR_DEFAULT_PLAYLIST_SORT;
}

interface PlaylistState {
  filters: IPlaylistFilter;
  sort: PlaylistSort;
  isFilterDrawerOpen: boolean;
}

const initialState: PlaylistState = {
  filters: {
    playlistStatus: undefined,
    searchText: "",
    showTitle: "",
    showId: "",
    durationInMinutes: undefined,
    guestCuratorId: "",
    playlistName: "",
    lastModified: undefined,
    dateAired: undefined,
    description: "",
  },
  sort: ADMIN_DEFAULT_PLAYLIST_SORT,
  isFilterDrawerOpen: false,
};

const playlistSlice = createSlice({
  name: "playlist",
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<Partial<IPlaylistFilter>>) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    resetFilters(state) {
      state.filters = {
        ...initialState.filters,
      };
    },
    setSort(state, action: PayloadAction<PlaylistSort>) {
      state.sort = action.payload;
    },
    resetSort(state, action: PayloadAction<{ role?: string } | undefined>) {
      state.sort = getDefaultPlaylistSort(action.payload?.role);
    },
    setFilterDrawerOpen(state, action: PayloadAction<boolean>) {
      state.isFilterDrawerOpen = action.payload;
    },
  },
});

export const {
  setFilters,
  resetFilters,
  setSort,
  resetSort,
  setFilterDrawerOpen,
} = playlistSlice.actions;

export default playlistSlice.reducer;
